import { render, staticRenderFns } from "./ReportDefectResult.vue?vue&type=template&id=5483abb2&scoped=true&"
import script from "./ReportDefectResult.vue?vue&type=script&lang=js&"
export * from "./ReportDefectResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483abb2",
  null
  
)

export default component.exports